import { $t } from '@previo/core'
import { Codebook } from '@previo/codebooks'

export enum CampaignCategoryId {
  AUTOMATED = 'automated',
  MARKETING = 'marketing',
}

export class CampaignCategory extends Codebook<CampaignCategoryId> {
  static readonly AUTOMATED = new CampaignCategory(CampaignCategoryId.AUTOMATED, () =>
    $t('Automated campaigns'),
  )
  static readonly MARKETING = new CampaignCategory(CampaignCategoryId.MARKETING, () =>
    $t('Marketing campaigns'),
  )

  private constructor(
    public readonly id: CampaignCategoryId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
